import { sendEvent } from '../../../configs/firebase'
import type { VideoCallSentiment } from '../../../ui/VideoCallRating/services'

type VideoCallRatingSource = 'call_end' | 'side_prompt' | 'unknown'
type VideoCallRatingCloseAction = 'close_button' | 'unknown'

const videoCallRatingAnalytics = {
  trackCallExitTriggered(appointmentId?: string): void {
    sendEvent('video_call_rating_call_exit_triggered', { appointmentId })
  },

  trackPromptView(appointmentId: string): void {
    sendEvent('video_call_rating_prompt_view', { appointmentId })
  },

  trackPromptSentimentSelected(
    appointmentId: string,
    sentiment: VideoCallSentiment
  ): void {
    sendEvent('video_call_rating_prompt_sentiment_selected', {
      appointmentId,
      sentiment,
    })
  },

  trackModalView(params: {
    appointmentId: string
    source?: VideoCallRatingSource
    hasInitialSentiment?: boolean
  }): void {
    sendEvent('video_call_rating_modal_view', {
      appointmentId: params.appointmentId,
      source: params.source ?? 'unknown',
      hasInitialSentiment: Boolean(params.hasInitialSentiment),
    })
  },

  trackClose(
    appointmentId: string,
    action: VideoCallRatingCloseAction = 'close_button'
  ): void {
    sendEvent('video_call_rating_modal_close', { appointmentId, action })
  },

  trackSubmit(params: {
    appointmentId: string
    sentiment: VideoCallSentiment
    selectedReasonsCount: number
    hasComment: boolean
  }): void {
    sendEvent('video_call_rating_submit', params)
  },

  trackSubmitSuccess(appointmentId: string): void {
    sendEvent('video_call_rating_submit_success', { appointmentId })
  },

  trackSubmitFailed(appointmentId: string): void {
    sendEvent('video_call_rating_submit_failed', { appointmentId })
  },
}

export default videoCallRatingAnalytics
